import * as React from 'react';
import { Button, TextField, Typography, Grid, Paper, Chip } from '@material-ui/core';
import BreadCrumb from '../../shared/components/BreadCrumb'
import OrganizationForm from '../components/OrganizationForm'
import SnackbarService from '../../core/services/SnackbarService'
import { NavLink } from 'react-router-dom';
import {defaultProvider} from '../../../constants'

import * as moment from 'moment'

import RequestService from '../../core/services/SubscriptionRequestService';
import Subscription from '../models/Subscription';
import User from '../models/User'

const requestservice = RequestService.Instance;
const snackbarService = SnackbarService.Instance;

import store from '../../../modules/core/store/index'
import { loadSubscriptionRequestStart } from '../../core/actions/subscriptionRequestActions'
import HistoryIcon from '@material-ui/icons/History'

interface IState {
  EditEntity: boolean
  verificationId: string
  subscription: Subscription
  isLoaded: boolean
  user: User
  correct: boolean
  remark: string
}

class Verifications extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      EditEntity: false,
      verificationId: this.props.match.params.verificationId,
      subscription: new Subscription(),
      isLoaded: false,
      user: new User(),
      correct: false,
      remark: ""
    }
    this.approve = this.approve.bind(this);
    this.deny = this.deny.bind(this);
  }

  public async componentDidMount() {
    const id = this.props.match.params.verificationId;
    const data: any = await requestservice.getSubscription(id);
    this.setState({
      subscription: data,
      verificationId: id,
      isLoaded: true,
      user: await requestservice.getUser(data.updateByUserId),
    })


  }

  public approve() {
    snackbarService.showSnackbar("success", "Request approved");
    requestservice.aproveRequest(this.state.subscription.id, true, this.state.remark);
    store.dispatch(loadSubscriptionRequestStart());
    this.props.history.push('/pending-subscriptions/' + this.state.subscription.environment.name);
  }

  public deny() {
    if (this.state.remark !== "") {
      snackbarService.showSnackbar("success", "Request denied");
      requestservice.aproveRequest(this.state.subscription.id, false, this.state.remark);
      store.dispatch(loadSubscriptionRequestStart());
      this.props.history.push('/pending-subscriptions/' + this.state.subscription.environment.name);
    } else {
      snackbarService.showSnackbar("error", "please add remark");
    }

  }

  public setcorrect = (s: boolean) => {
    if (this.state.correct !== s) {
      this.setState({ correct: s });
    }
  }

  public remarkChange = (event: any) => {
    this.setState({ remark: event.target.value })
  }

  public render() {
    const isDefaultSubscriptionProvider = this.state.subscription.subscriptionProvider === defaultProvider;
    return (
      <div>
        <Typography variant="title" gutterBottom={true}>
          {this.state.subscription.product ? this.state.subscription.product.asset.name + " | " + this.state.subscription.environment.name + " environment | " + this.state.subscription.state.name + " subscriptions" : ""}
        </Typography>
        <Typography color="textSecondary" gutterBottom={true}>
          <BreadCrumb
            value='Console'
            to='/'
          />
          <BreadCrumb
            value='Assets'
            to='/verifications/'
          />
          Request Verification
        </Typography>
        {this.state.subscription.subscriptionProvider !== defaultProvider &&
          <div className="padding-bottom-24">
            <Chip className='full-width' label={"This subscription is linked to external service provider " + this.state.subscription.subscriptionProvider+". Some functionality is limited."} />
          </div>
        }
        <Paper className="padding-24">
          <Grid container={true} spacing={24} alignItems="center">
            <Grid item={true} xs={2}>
              <TextField
                name="requestDate"
                label="Request Date"
                value={this.state.isLoaded ? moment(new Date(this.state.subscription.createdOn)).format('YYYY-MM-DD') : "date"}
                disabled={true}
              />
            </Grid>
            <Grid item={true} xs={2}>
              <TextField
                name="asset"
                label="Asset"
                value={this.state.isLoaded ? this.state.subscription.product.asset.name : "Asset"}
                disabled={true}
              />
            </Grid>
            <Grid item xs={7} />
            <Grid item xs={1}>
              <Button component={(componentProps: any) => <NavLink {...componentProps} to={this.state.subscription.product ? "/verification-history/" + this.state.subscription.product.asset.id + "/" + this.state.verificationId : ""} />} >
                <Grid container direction="column" alignItems="center">
                  <Grid item>
                    <HistoryIcon color="secondary" />
                  </Grid>
                  <Grid item>
                    <Typography color="secondary">
                      History
                    </Typography>
                  </Grid>
                </Grid>
              </Button>

            </Grid>
          </Grid>
        </Paper>
        <div className='padding-bottom-24' />
        <Grid container={true} spacing={8} alignItems="center">
          <Grid item={true}>
            <Typography variant="subheading" gutterBottom={true}>
              Organization
            </Typography>
          </Grid>
        </Grid>

        {this.state.isLoaded &&
          <OrganizationForm
            entity={this.state.subscription.entityId}
            assetId={this.state.isLoaded ? this.state.subscription.product.asset.id : ""}
            subscriptionId={this.state.subscription.id}
            isDefaultSubscriptionProvider={isDefaultSubscriptionProvider}
          />}
        <div className='padding-bottom-24' />

        <Typography variant="subheading" gutterBottom>
          Remark
        </Typography>
        <Paper className="padding-24 ">
          <TextField
            fullWidth={true}
            name="message"
            multiline={true}
            rows={5}
            margin="normal"
            onChange={this.remarkChange}
            disabled={this.props.match.path === "/subscriptiondetails/:verificationId"}
          />
        </Paper>
        <div className='padding-bottom-24' />
        {this.props.match.path !== "/subscriptiondetails/:verificationId" && isDefaultSubscriptionProvider &&
          <Grid container spacing={24}>
            <Grid item>
              <Button variant="outlined" color="secondary" onClick={this.approve}>
                Approve
              </Button>
            </Grid>
            <Grid item={true}>
              <Button variant="outlined" color="secondary" onClick={this.deny}>
                Deny
              </Button>
            </Grid>
          </Grid>}
      </div>
    )
  }
}

export default Verifications


// WEBPACK FOOTER //
// ./src/modules/subscription/pages/Verification.tsx